import {Color} from '../types';

import {
  COLOR__LIGHT_BACK,
  COLOR__LIGHT_GRAY,
  COLOR__MAGENTA_LIGHT,
  COLOR__MAGENTA_SOFT_DARK,
  COLOR__PRIMARY,
  COLOR__PRIMARY_LIGHT,
} from '@/theme/colors';

interface LabelColors {
  bgColor: Color;
  textColor: Color;
}

// Entity labels (`matched`, `exited`, …) look the same wherever they appear:
// in transactions, in orders. The keys are backend-specific.
const label2Colors: Record<string, LabelColors> = {
  matched: {bgColor: COLOR__PRIMARY_LIGHT, textColor: COLOR__PRIMARY},
  exited: {bgColor: COLOR__MAGENTA_LIGHT, textColor: COLOR__MAGENTA_SOFT_DARK},
  resolved: {bgColor: '#DBF5F4', textColor: '#108E85'},
  // Orders call it `result`, transactions call it `resolved`
  result: {bgColor: '#DBF5F4', textColor: '#108E85'},
};

const defaultLabelColors: LabelColors = {
  bgColor: COLOR__LIGHT_BACK,
  textColor: COLOR__LIGHT_GRAY,
};

export const getLabelColors = (label: string): LabelColors =>
  label2Colors[label] ?? defaultLabelColors;
